export default {
    // "api_url": "http://localhost:7071/",
    "api_url": "https://api.epiwatch.app/api/v2/",
    "recaptchaSiteKey": "6LeXfZUcAAAAAIbuyKbg52VkrHyS0XMbcpjMQXz8"
}
